import { DEPENDENCY_WHEEL_COMPONENTS_LIMIT } from 'views/environmentals/viewDataLimits';

export const getWarningMessage = (
  totalComponentsCount: number,
  isExplorerMode: boolean,
  isPresentationMode: boolean
) => {
  const stringEnding = `Reduce the scope by ${
    isPresentationMode
      ? `${
          !isExplorerMode ? 'enabling explore mode and ' : ''
        }double clicking a specific component.`
      : 'selecting a specific component or applying filters.'
  }`;

  return `There are too many components to show (${totalComponentsCount}). We have displayed the first ${DEPENDENCY_WHEEL_COMPONENTS_LIMIT}. ${stringEnding}`;
};
